<div class="grid">
  <div
    class="progress mat-body-large"
    [ngClass]="{
      'progress-active': showProgress(),
      'in-progress': status() === 'in-progress',
      error: status() === 'error',
    }"
  >
    <mat-icon>
      @switch (status()) {
        @case ('done') {
          check
        }
        @case ('in-progress') {
          exclamation
        }
        @case ('error') {
          close
        }
      }
    </mat-icon>
  </div>
  <p class="mat-body-large title">{{ title() }}</p>
  <p class="mat-body-small">
    <ng-content></ng-content>
  </p>
</div>
